import styled from "styled-components";
import { Card } from "@mui/material";
import Typography from "component/commonComponents/Typography";

interface ICountDownCardProps{
    isOffboarding?: boolean
}

export const StyledCard = styled(Card)<ICountDownCardProps>(({ theme, isOffboarding = false }) => `
    width: 100%;
    height: 51px;
    background: ${theme.uptimeColors.grayScales.white};
    padding: 6px; 
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${isOffboarding ? "8px" : "20px"};
    @media (min-width: ${theme.breakpoints.md}) {
      height: 82px;
    }
`);


export const StyledCol = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledTypographyHeader = styled(Typography)(({ theme }) => `   
    font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
    line-height: unset;
    color: ${theme.uptimeColors.mainTheme.primary};
    font-weight: bolder;
    display: flex;
    align-items: center;
    flex-direction: column;
`);


export const StyledTypographyDesc = styled(Typography)(({ theme }) => `   
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    line-height: unset;
    color: ${theme.uptimeColors.mainTheme.primary};
    font-weight: bolder;
`);
